import type { AgentDetail } from "../../api/admin-agents";
import { t } from "../../i18n";
import { s } from "./agent-detail-styles";

export type AgentAction =
  | "restrict"
  | "restore"
  | "unpublish"
  | "ban"
  | "rotate"
  | "activate-paid-access";

export function AgentActionButtons({
  agent,
  onAction,
}: {
  agent: AgentDetail;
  onAction: (action: AgentAction) => void;
}): React.JSX.Element {
  if (agent.governance_status === "banned") {
    return <span style={s.bannedLabel}>{t("agent_detail.banned")}</span>;
  }

  return (
    <div style={s.actionGroup}>
      {canUnpublish(agent) && (
        <ActionButton
          label={t("agent_detail.unpublish_agent")}
          style={s.warningBtn}
          onClick={() => onAction("unpublish")}
        />
      )}
      {canActivatePaidAccess(agent) && (
        <ActionButton
          label={t("agent_detail.activate_paid_access")}
          style={s.primaryBtn}
          onClick={() => onAction("activate-paid-access")}
        />
      )}
      {agent.governance_status !== "active" && (
        <ActionButton
          label={t("agent_detail.restore_agent")}
          style={s.primaryBtn}
          onClick={() => onAction("restore")}
        />
      )}
      <ActionButton
        label={t("agent_detail.rotate_identity")}
        style={s.dangerBtn}
        onClick={() => onAction("rotate")}
      />
      {agent.governance_status === "active" && (
        <ActionButton
          label={t("agent_detail.restrict_agent")}
          style={s.dangerBtn}
          onClick={() => onAction("restrict")}
        />
      )}
      <ActionButton
        label={t("agent_detail.ban_agent")}
        style={s.dangerBtn}
        onClick={() => onAction("ban")}
      />
    </div>
  );
}

function ActionButton({
  label,
  style,
  onClick,
}: {
  label: string;
  style: React.CSSProperties;
  onClick: () => void;
}): React.JSX.Element {
  return (
    <button type="button" style={style} onClick={onClick}>
      {label}
    </button>
  );
}

function canUnpublish(agent: AgentDetail): boolean {
  return (
    agent.listing.visibility === "public" &&
    agent.listing.listing_status === "published"
  );
}

function canActivatePaidAccess(agent: AgentDetail): boolean {
  return agent.listing.monetization_status === "paid_pending_review";
}
